import { render } from "./MultiSelectDropdown.vue?vue&type=template&id=37cb10e2"
import script from "./MultiSelectDropdown.vue?vue&type=script&lang=js"
export * from "./MultiSelectDropdown.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"

import exportComponent from "/var/www/water.jatriweb.team/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__